import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-redux-i18n';
import { Icon } from 'front-onceforall-core';
import { Tooltip } from '@material-ui/core';
import { TASK_TYPE } from '../../../../utils/constant';
import momentPropTypes from 'react-moment-proptypes';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const slash = '/';
export const ParticipantView = props => {
  const rejectButton = /*#__PURE__*/_jsx(Tooltip, {
    "data-id": "reject-tooltip",
    title: /*#__PURE__*/_jsx(Translate, {
      value: "request.page.rejectRequest"
    }),
    children: /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "large secondary inline-container",
      "data-id": "reject-button",
      onClick: () => props.onRejectRequestClick(),
      children: /*#__PURE__*/_jsx(Icon, {
        icon: "cross"
      })
    })
  });
  let requestValidationState = /*#__PURE__*/_jsxs("div", {
    className: "flex-container flex-end",
    children: [/*#__PURE__*/_jsx(Icon, {
      className: props.requestValidationStateColor,
      icon: props.requestValidationStateIcon
    }), /*#__PURE__*/_jsx(Translate, {
      value: props.requestValidationStateTranslation
    })]
  });
  requestValidationState = props.previousActionDate && props.previousActionUserName ? /*#__PURE__*/_jsx(Tooltip, {
    "data-id": "validation-tooltip",
    title: /*#__PURE__*/_jsx(Translate, {
      value: props.requestValidationStateType,
      date: props.previousActionDate.format('L'),
      user: props.previousActionUserName
    }),
    children: requestValidationState
  }) : requestValidationState;
  const conditionState = props.condition ? /*#__PURE__*/_jsx(Tooltip, {
    "data-id": "condition-tooltip",
    title: props.condition,
    children: /*#__PURE__*/_jsx("div", {
      className: `flex-container flex-end ${props.requestValidationStateColor}`,
      style: {
        whiteSpace: 'nowrap'
      },
      children: /*#__PURE__*/_jsx(Translate, {
        value: props.conditionTranslation + 'title'
      })
    })
  }) : null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: `box border bottom ${props.isLast ? 'mb-0' : ''}`,
      children: [/*#__PURE__*/_jsxs("div", {
        className: "card-header",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "font-size-xl",
          style: {
            maxWidth: '65%'
          },
          children: [/*#__PURE__*/_jsx("div", {
            className: "inline-container",
            children: props.position
          }), "\xA0", slash, "\xA0", /*#__PURE__*/_jsx(Translate, {
            value: `request.page.${props.task?.role}`,
            level: props.task?.roleLevel
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex-column",
          children: [requestValidationState, conditionState]
        })]
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex-container space-between",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex-column",
            style: {
              paddingLeft: 'calc(100% / 25)'
            },
            children: [/*#__PURE__*/_jsx("b", {
              className: "font-size-xl",
              children: props.participant?.fullName
            }), /*#__PURE__*/_jsx("div", {
              className: "information",
              children: props.participant?.registrationNumber
            })]
          }), props.areUserActionsAllowed && props.isSignatory && props.task.type === TASK_TYPE.SIGN && /*#__PURE__*/_jsxs("div", {
            className: "inline-container",
            children: [rejectButton, /*#__PURE__*/_jsx(Tooltip, {
              title: /*#__PURE__*/_jsx(Translate, {
                value: "request.documents.actions.sign"
              }),
              children: /*#__PURE__*/_jsx("button", {
                type: "button",
                className: "large secondary inline-container",
                "data-id": "sign-button",
                onClick: () => props.onSignClick(props.task.role),
                children: /*#__PURE__*/_jsx(Icon, {
                  icon: "sign"
                })
              })
            })]
          }), props.areUserActionsAllowed && props.isVerificatorOnly && props.task.type === TASK_TYPE.VERIFY && !props.isVerified && /*#__PURE__*/_jsxs("div", {
            className: "inline-container",
            children: [rejectButton, /*#__PURE__*/_jsx(Tooltip, {
              title: /*#__PURE__*/_jsx(Translate, {
                value: "request.documents.actions.verify"
              }),
              children: /*#__PURE__*/_jsx("button", {
                type: "button",
                className: "large secondary inline-container",
                "data-id": "verify-button",
                onClick: () => props.onVerifyClick(props.task.role),
                children: /*#__PURE__*/_jsx(Icon, {
                  icon: "check"
                })
              })
            })]
          }), (props.isSignatory || props.isVerificatorOnly) && props.canRemoveCondition && /*#__PURE__*/_jsx(Tooltip, {
            title: /*#__PURE__*/_jsx(Translate, {
              value: props.conditionTranslation + 'tooltip'
            }),
            children: /*#__PURE__*/_jsx("button", {
              type: "button",
              className: "large secondary inline-container",
              "data-id": "delete-condition-button",
              onClick: () => props.onRemoveConditionClick(),
              children: /*#__PURE__*/_jsx(Icon, {
                icon: "trash"
              })
            })
          })]
        })
      })]
    })
  });
};
ParticipantView.defaultProps = {
  condition: null,
  position: 1,
  isLast: false,
  requestValidationStateIcon: 'error',
  requestValidationStateTranslation: '',
  previousActionDate: null,
  previousActionUserName: null
};
ParticipantView.propTypes = {
  task: PropTypes.object,
  previousActionDate: momentPropTypes.momentObj,
  previousActionUserName: PropTypes.string,
  participant: PropTypes.object,
  position: PropTypes.number,
  condition: PropTypes.string,
  isLast: PropTypes.bool,
  isVerified: PropTypes.bool,
  isVerificatorOnly: PropTypes.bool,
  isSignatory: PropTypes.bool,
  areUserActionsAllowed: PropTypes.bool,
  canRemoveCondition: PropTypes.bool,
  shouldHaveTooltip: PropTypes.bool,
  requestValidationStateIcon: PropTypes.string,
  requestValidationStateColor: PropTypes.string,
  requestValidationStateTranslation: PropTypes.string,
  requestValidationStateType: PropTypes.string,
  conditionTranslation: PropTypes.string,
  onSignClick: PropTypes.func.isRequired,
  onVerifyClick: PropTypes.func.isRequired,
  onRejectRequestClick: PropTypes.func.isRequired,
  onRemoveConditionClick: PropTypes.func.isRequired
};
export default ParticipantView;